export default "__VITE_ASSET__DWlem4dt__"